<script setup lang="ts">
import { onMounted, useTemplateRef } from 'vue'
import { RouterView } from 'vue-router'
import bus from '@/utils/bus'

const appMain = useTemplateRef<HTMLElement>('appMain')

onMounted(() => {
  appMain.value?.addEventListener(
    'scroll',
    e => {
      bus.emit('mainScroll', e)
    },
    {
      passive: true
    }
  )
})
</script>

<template>
  <TitleBar title="novalander" />

  <main
    ref="appMain"
    class="app-main"
  >
    <RouterView />
  </main>

  <div class="safe-area-bottom-height" />
</template>

<style>
.app-main {
  flex: 1;
  overflow: auto;
  z-index: 10;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(248, 78, 63, 0.1);
    border-radius: 50%;
    border-top-color: #f84e3f;
    animation: spin 1s ease-in-out infinite;
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
